import { baseURL } from "../utils/constants";
import apiClient from "./fetch";

export const getPrescriptionTemplatesByDoctorId = async (doctor_id: string) => {
  try {
    const response = await apiClient.get(
      `${baseURL}/prescriptions/templates/doctor/${doctor_id}`
    );
    console.log(response);
    return response; // Ensure only the data is returned
  } catch (error: any) {
    if (error.response) {
      console.error("API Error Response:", error.response.data);
      return error.response.data; // Return error response so it can be handled in UI
    } else {
      console.error("Unexpected API Error:", error);
      throw error;
    }
  }
};

export const getPrescriptionTemplatesByTemplateId = async (
  template_id: string
) => {
  try {
    const response = await apiClient.get(
      `${baseURL}/prescriptions/templates/template/${template_id}`
    );
    console.log(response);
    return response; // Ensure only the data is returned
  } catch (error: any) {
    if (error.response) {
      console.error("API Error Response:", error.response.data);
      return error.response.data; // Return error response so it can be handled in UI
    } else {
      console.error("Unexpected API Error:", error);
      throw error;
    }
  }
};

export const deletePrescriptionTemplatesByTemplateId = async (
  template_id: string
) => {
  try {
    const response = await apiClient.delete(
      `${baseURL}/prescriptions/templates/template/${template_id}`
    );
    console.log(response);
    return response; // Ensure only the data is returned
  } catch (error: any) {
    if (error.response) {
      console.error("API Error Response:", error.response.data);
      return error.response.data; // Return error response so it can be handled in UI
    } else {
      console.error("Unexpected API Error:", error);
      throw error;
    }
  }
};

export const sendPrescriptionTemplateWithPdfLink = async (
  booking_id: string | null,
  pdf_link: string
) => {
  try {
    const response = await apiClient.post(
      `${baseURL}/prescriptions/templates/template/send`,
      {
        booking_id: booking_id,
        pdf_link: pdf_link,
      }
    );
    console.log(response);
    return response; // Ensure only the data is returned
  } catch (error: any) {
    if (error.response) {
      console.error("API Error Response:", error.response.data);
      return error.response.data; // Return error response so it can be handled in UI
    } else {
      console.error("Unexpected API Error:", error);
      throw error;
    }
  }
};

export const sendPrescriptionTemplateWithPdfLinkDirect = async (
  patient_contact_number: string | null,
  pdf_link: string,
  patient_full_name: string | null,
  hospital_id: string | null,
  doctor_full_name: string | null,
  date: string | null
) => {
  try {
    const response = await apiClient.post(
      `${baseURL}/prescriptions/sendtopatientdirectly`,
      {
        patient_contact_number: patient_contact_number,
        pdf_link: pdf_link,
        patient_full_name: patient_full_name,
        hospital_id: hospital_id,
        doctor_full_name: doctor_full_name,
        date: date,
      }
    );
    console.log(response);
    return response; // Ensure only the data is returned
  } catch (error: any) {
    if (error.response) {
      console.error("API Error Response:", error.response.data);
      return error.response.data; // Return error response so it can be handled in UI
    } else {
      console.error("Unexpected API Error:", error);
      throw error;
    }
  }
};

export const createPrescriptionTemplate = async (
  template_name: string | null,
  doctor_id: string,
  data: string
) => {
  try {
    const response = await apiClient.post(
      `${baseURL}/prescriptions/templates/template`,
      {
        template_name: template_name,
        doctor_id: doctor_id,
        data: data,
      }
    );
    console.log(response);
    return response; // Ensure only the data is returned
  } catch (error: any) {
    if (error.response) {
      console.error("API Error Response:", error.response.data);
      return error.response.data; // Return error response so it can be handled in UI
    } else {
      console.error("Unexpected API Error:", error);
      throw error;
    }
  }
};

export const updatePrescriptionTemplate = async (
  template_id: string | null,
  template_name: string | null,
  doctor_id: string,
  data: string
) => {
  try {
    const response = await apiClient.patch(
      `${baseURL}/prescriptions/templates/template/${template_id}`,
      {
        template_name: template_name,
        doctor_id: doctor_id,
        data: data,
      }
    );
    console.log(response);
    return response; // Ensure only the data is returned
  } catch (error: any) {
    if (error.response) {
      console.error("API Error Response:", error.response.data);
      return error.response.data; // Return error response so it can be handled in UI
    } else {
      console.error("Unexpected API Error:", error);
      throw error;
    }
  }
};

interface GeneratePrescriptionRequest {
  currentData: {
    complaints: string;
    historyAndExaminations: string;
    diagnosis: string;
    investigations: string;
    previousMedicines: string;
    medicines: Array<{
      name: string;
      dosage: string;
      duration: string;
    }>;
    advice: string;
    signature: string;
    template_name: string;
  };
  prompt: string;
}

interface GeneratePrescriptionResponse {
  status: number;
  data: {
    result: GeneratePrescriptionRequest["currentData"];
  };
  error?: string;
}

export const generatePrescriptionWithAI = async (
  currentData: GeneratePrescriptionRequest["currentData"],
  prompt: string
): Promise<GeneratePrescriptionResponse> => {
  try {
    const response = await apiClient.post<GeneratePrescriptionResponse>(
      `${baseURL}/prescriptions/generate-with-ai`,
      {
        currentData,
        prompt,
      }
    );
    return response.data;
  } catch (error: any) {
    if (error.response) {
      console.error("API Error Response:", error.response.data);
      return error.response.data;
    } else {
      console.error("Unexpected API Error:", error);
      throw error;
    }
  }
};
